import styled, { css } from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import MuiStepper from '@material-ui/core/Stepper';
import MuiStep from '@material-ui/core/Step';
import MuiStepLabel from '@material-ui/core/StepLabel';
import MuiTextField from '@material-ui/core/TextField';
import MenuItem from "@material-ui/core/MenuItem";

export const OuterWrapper = styled.div`
  max-width: 1108px;
  margin: 0 auto;
  background: #eef6f6;
  top: -198px;
  position: relative;
  border-radius: 4px;

  @media screen and (max-width: 768px) {
    position: static;
  }
`;
export const InnerWrapper = styled.div`
  max-width: 918px;
  margin: 0 auto;
  padding: 40px 15px;
`;

export const StepperHeading = styled(MuiStepper)`
  padding: 0;
  background: transparent;
  margin-bottom: 40px;

  @media screen and (max-width: 768px) {
    margin-bottom: 30px;
  }
`;

export const Step = withStyles({
  root: {
    flex: '1',
    paddingBottom: '18px',
    borderBottom: (props) =>
      props.active || props.completed
        ? '2px solid #036663'
        : '1px solid rgba(3, 102, 99, 0.1)',
  },
})(MuiStep);

export const StepLabel = withStyles({
  root: {
    justifyContent: 'center',
  },
  labelContainer: {
    width: 'unset',
  },
  active: {},
  completed: {},
  label: {
    color: '#02706D',
    '&$active,&$completed': {
      fontWeight: 600,
      color: '#02706D',
    },
  },
})(MuiStepLabel);

export const StepIcon = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: solid #036663;
  border-width: ${(props) => (props.active ? '2' : '1')}px;
  box-sizing: border-box;
  background-color: ${(props) => (props.completed ? '#036663' : 'transparent')};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: background-color 200ms;
`;
export const StepIconImg = styled.img`
  width: 14px;
`;

export const ControlsWrapper = styled.div`
  display: flex;
  margin-top: 40px;

  @media screen and (max-width: 768px) {
    display: block;
  }
`;
export const ControlsGroupWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex: 1;

  @media screen and (max-width: 768px) {
    margin-bottom: 30px;
  }
  @media screen and (max-width: 375px) {
    display: block;
  }
`;
export const TextFieldWrapper = styled.div`
  flex: 1;

  & + & {
    margin-left: 30px;

    @media screen and (max-width: 375px) {
      margin-left: 0;
      margin-top: 30px;
    }
  }
  
  input {
    color: #013E3E;
    font-size: 14px;
    
    &::placeholder {
      color: #013E3E;
      font-size: 14px;
      opacity: 1;
    }
  }
`;

export const MenuItemWrap = withStyles({
  root: {
    color: '#013e3e',
  },
})(MenuItem);

export const TextField = withStyles({
  root: {
    borderColor: 'red',
  },
})(MuiTextField);

export const SelectWrapper = styled.div`
  flex: 0 0 350px;
  margin-left: 30px;

  label {
    color: #013E3E;
    font-size: 14px;
  }

  @media screen and (max-width: 768px) {
    margin-left: 0;
  }
`;
export const CheckboxWrapper = styled.div`
  margin-top: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const CheckboxLabel = styled.span`
  font-weight: 400;
  font-size: 12px;
  line-height: 150%;
  color: #02706d;
`;
export const InlineLink = styled.a`
  font-weight: 300;
  font-size: 12px;
  line-height: 150%;
  text-decoration: none;
  color: #fa7814;
`;

export const ControlWrapper = styled.div`
  margin: 36px 0;
  display: flex;
  justify-content: center;

  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

export const Heading = styled.p`
  margin: 0 0 24px;
  text-align: center;
  font-weight: 600;
  font-size: 20px;
  line-height: 150%;
  color: #02706d;
`;

export const RatingWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
export const StarIconWrapper = styled.span`
  align-items: flex-start;
`;
export const StarCaption = styled.p`
  text-align: center;
  font-weight: ${(props) => (props.bold ? '600' : 'normal')};
  font-size: 12px;
  line-height: 18px;
  margin: 8px 0;
  color: #02706d;
`;

export const Text = styled.p`
  font-size: ${(props) => (props.small ? 12 : 16)}px;
  line-height: 180%;
  font-weight: 300;
  color: #02706d;
  text-align: center;
`;
export const DiscountText = styled.span`
  font-weight: 500;
  color: #fa7814;
`;

const controlCss = css`
  border: 0;
  min-width: 158px;
  padding: 18px;
  cursor: pointer;
  background: #02706D;
  border-radius: 5px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-decoration: none;
  font-weight: bold;
  font-size: 14px;
  line-height: 17px;
  transition: transform 300ms ease-in-out, background 300ms ease-in-out;

  @media screen and (max-width: 768px) {
    width: 100%;
  }

  &:hover {
    background: #02817d;
  }

  &:focus {
    background: #03a39e;
  }

  &:active {
    transform: scale(1.05);
  }

  &:disabled {
    background: #828282;
    cursor: default;
  }
`;
export const Button = styled.button`
  ${controlCss};
`;
export const Link = styled.a`
  ${controlCss};
  text-decoration: none;
`;

export const InfoWrapper = styled.div`
  max-width: 568px;
  margin: 0 auto;
  //padding-top: 40px;
`;

export const ErrorMessage = styled(InfoWrapper)`
  display: flex;
  align-items: flex-start;
  background: #fcecec;
  margin: 20px auto;
  padding: 14px;
  border: 1px solid #f6dede;
  border-radius: 5px;
  font-size: 14px;
  line-height: 24px;
`;
export const ErrorMessageIconImg = styled.img`
  width: 20px;
  margin-right: 8px;
`;
